import { AutocompleteProps } from '@material-ui/lab/Autocomplete';
// eslint-disable-next-line
import React from 'react';

import { TextFieldProps } from 'formik-material-ui';
import { useGetCities } from './hooks';
import AutocompleteDomicile from './AutocompleteDomicile';

type Props = {
  region: { id: string; name: string };
  childrenFields: { fieldName: string }[];
} & TextFieldProps &
  Partial<AutocompleteProps>;

const CityAutocomplete: React.FC<Props> = ({
  region,
  form,
  field,
  children,
  label,
  childrenFields = [],
  ...restProps
}) => {
  const regionName = region?.name ?? '';
  const { data, error, isLoading } = useGetCities(regionName);

  return (
    <AutocompleteDomicile
      isLoading={isLoading}
      field={field}
      data={data}
      label={label}
      form={form}
      error={error}
      childrenFields={childrenFields}
      {...restProps}
    />
  );
};

export default CityAutocomplete;
